const VIEWS = {
    ATTACHMENTS: "ATTACHMENTS",
    LETTERS: "LETTERS",
    WEBFORMS: "WEBFORMS",
    CERTIFICATES: "CERTIFICATES"
};

export default {
    VIEWS
};
